import type { NextPage } from 'next'
import Head from 'next/head'
import Image from 'next/image'
import styles from '../styles/Home.module.css'
import React from 'react'
import Link from 'next/link'
import Script from 'next/script'

interface CommonProps {}

const Common: NextPage<React.PropsWithChildren<CommonProps>> = ({ children }) => {
  return (
    <div className={styles.container}>
      <Head>
        <title>What&apos;s for Lunch in the Perth CBD?</title>
        <meta name="description" content="Minimalist random where to eat app" />
        {/* https://www.favicon.cc/?action=icon&file_id=121153 Creative Commons, no attribution */}
        <link
          href="data:image/x-icon;base64,AAABAAEAEBAAAAAAAABoBQAAFgAAACgAAAAQAAAAIAAAAAEACAAAAAAAAAEAAAAAAAAAAAAAAAEAAAAAAAAAAAAADhINABcOBABtdWoA65ETAA8JAgAtOCoAHBEGAOvgEwBPRz4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAQIBAQECAgIBAQECAQEBAgIBAQECAQEBAgIBAQEBAQEBAQICAQEBAQEBAgEBAgECAQIBAQJCQkJCQkECAQECAQIBAQJBQUFAwUFCQQEBAQIBAQJAgICAwICAgIJBAgIBAgJAgIHAwcHBwkCAggEBAAJAgMDBwcHBwkBBwIAAAAJAgICBwcHBwkBAAcCAAAAAAkJBwcHCQkBAAcCAAAAAAAAAAkJCQEAAAcCAAAAAAAAAAAAAAAAAAcCAAACAAAAAAAAAAAAAAYCAgICAAAAAAAAAAAAAAAGAgIDAgAAAAAAAAAAAAAAAAYHBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACABwAAACcAAIBPAADhnwAA/zcAAP4PAAD+DwAA/x8AAP//AAA="
          rel="icon"
          type="image/x-icon"
        />
        <meta property="og:title" content="What's for Lunch in the Perth CBD?" />
        <meta
          property="og:description"
          content="No options, no pros and cons lists, no risk matrices, no SWOT analyses, no ROI calcs needed. No stress, just hit random!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://where-to-for-lunch-perth.vercel.app/" />
        <meta
          property="og:image"
          content="https://where-to-for-lunch-perth.vercel.app/og-image.png"
        />
        <script
          async
          defer
          data-website-id="19d25660-643c-4c9c-9037-256d7893cb7c"
          src="https://umami.abundantsalmon.com/script.js"
        ></script>
      </Head>
      <main className={styles.main}>
        <h1 className={styles.title}>What&apos;s for Lunch in the Perth CBD?</h1>
        {children}
      </main>

      <footer className={styles.footer}>
        <Link href="/">
          <a>Home</a>
        </Link>

        <a href="https://github.com/AbundantSalmon/">
          Created by&nbsp;
          <Image src="/GitHub-Mark-32px.png" alt="Github Icon" width={16} height={16} />
          &nbsp;AbundantSalmon
        </a>

        <Link href="/faq">
          <a>FAQ</a>
        </Link>
      </footer>
    </div>
  )
}

export default Common
